import React from 'react';
import ReactDOM from 'react-dom';



class VideoPlayBack extends React.Component{
  
  constructor(props){
    super(props);

    this.state = {
      loadStatus : 0,
    }
   
    this.update = requestAnimationFrame(()=>this.loop());
    
  }

  cancelAnimationFrame(){
    cancelAnimationFrame(this.update);
  }

  loop(){
    this.update = requestAnimationFrame(()=>this.loop());
    console.log();

    this.setState({
      loadStatus : _assets.getLoadStatus()
    })
  }
  
  render(){
    return (<div>
          <span className="helper">{this.state.loadStatus}</span>
          </div>);
  }
}


export default VideoPlayBack;



// WEBPACK FOOTER //
// ./src/scripts/VideoPlayBack.js